module.exports = __webpack_public_path__ + "img/take_status2.7da3fd34.png";